<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-vacaciones />
    <VerReporte />
    <h3 class="primary--text">
      <v-icon color="primary">today</v-icon> Vacaciones
    </h3>
    <v-card>
      <v-card-text>
        <p>
          <strong>Nombre: </strong>{{ this.$storage.get("user").nombres }}
          {{ this.$storage.get("user").ap_paterno }}
          {{ this.$storage.get("user").ap_materno }}
        </p>
        <p
          v-if="
            fecha_ingreso ==
            'No existe registros de la fecha de su incorporación'
          "
        >
          <strong>Fecha de incorporación: </strong>{{ fecha_ingreso }}
        </p>
        <p
          v-if="
            fecha_ingreso !=
            'No existe registros de la fecha de su incorporación'
          "
        >
          <strong>Fecha de incorporación: </strong
          >{{ $moment(fecha_ingreso).format("DD/MM/YYYY") }}
        </p>

        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
          :estiloCabecera="'estilo-cabecera-customizada'"
        >
        <!-- <tr
              :id="items.item.id_estado_programacion!=72 ? 'celda_morada': ''"
            > -->
          <template slot="items" slot-scope="items">
           
            <td :id="items.item.id_estado_programacion!=72 ? 'celda_morada': ''" class="text-xs-center">{{ items.item.periodo }}</td>
       
            <td :id="items.item.id_estado_programacion!=72 ? 'celda_morada': ''" class="text-xs-center">{{ items.item.estado_programacion }}</td>
            <td :id="items.item.id_estado_programacion!=72 ? 'celda_morada': ''" class="nowrap text-xs-center">
              <v-btn
                v-if="bandera_alta_persona && items.item.id_estado_programacion==72"
                color="info"
                :to="`programar/${items.item.gestion_hasta}`"
                icon
                title="Ver detalle"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                v-if="bandera_alta_persona && items.item.id_estado_programacion!=72"
                color="info"
                :to="`programar/${items.item.gestion_hasta}`"
                icon
                title="Programar"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                v-if="bandera_alta_persona == false"
                color="info"
                @click.prevent="mensajeBajaPersona()"
                icon
                title="Ver detalle"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
             
              <v-btn
                color="#f3cb19"
                @click.prevent="verReporte(items.item, 2)"
                icon
                title="Ver reporte del cronograma de vacaciones de la gestión"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
            </td>
         
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table-cabecera-customizada/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table-cabecera-customizada/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarVacaciones from "./dialogs/CrearActualizarVacaciones"; // Componente de creación y actualización
import VerReporte from "./dialogs/VerReporte";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  // Variables iniciales del componente
  data() {
    let user = this.$storage.get("user");
    let id_persona = user.id_persona;
    return {
      url: "vEstadoVacacions",
      graphql: true,
      bandera_alta_persona: true,
      // Cabecera de la tabla
      initData: [
        {
          state: true,
          param: "id_persona",
          value: id_persona,
        },
      ],
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        { text: "Gestión programación", value: "periodo", align: "center" },
        // { text: "Gestión desde", value: "gestion_desde", align: "center" },
        // { text: "Gestión hasta", value: "gestion_hasta", align: "center" },
        // { text: "Días asignados", value: "dias_asignados", align: "center" },
        // { text: "Cas", value: "cas", align: "center" },
        // {
        //   text: "Días programados",
        //   value: "dias_programados",
        //   align: "center",
        // },
        // {
        //   text: "Saldo acumulado \n Días asignados + Saldo gestión",
        //   value: "total_dias_saldo",
        //   align: "center",
        // },
        // { text: "Dias saldo gestión", value: "dias_saldo", align: "center" },
        // { text: "Estado gestión", value: "estado", align: "center" },
        {
          text: "Estado programación",
          value: "id_estado_programacion",
          align: "center",
        },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        nombre
      dias_saldo
      dias_asignados
      dias_utilizados
      dias_programados
      dias_cta_vacacion
      id
      id_estado
      id_persona
      nombre
      ingreso
      gestion_desde
      gestion_hasta
       estado
      cas
      saldo_a_programar
      total_dias_saldo
      id_programacion
      id_estado_programacion
      id_unidad
      estado_programacion
      periodo
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: [
        {
          field: "periodo",
          label: "Gestión programación",
          type: "number", // Tipo de input en el filtro
          typeG: "String", // Tipo definido en Graphql
        },
        // {
        //   field: "gestion_desde",
        //   label: "Gestión desde",
        //   type: "text", // Tipo de input en el filtro
        //   typeG: "String", // Tipo definido en Graphql
        // },
        // {
        //   field: "gestion_hasta",
        //   label: "Gestión hasta",
        //   type: "text", // Tipo de input en el filtro
        //   typeG: "String", // Tipo definido en Graphql
        // },
        // {
        //   field: "dias_asignados",
        //   label: "Días asignados",
        //   type: "number", // Tipo de input en el filtro
        //   typeG: "String", // Tipo definido en Graphql
        // },
        // {
        //   field: "cas",
        //   label: "Cas",
        //   type: "text", // Tipo de input en el filtro
        //   typeG: "String", // Tipo definido en Graphql
        // },
        // {
        //   field: "dias_programados",
        //   label: "Días programados",
        //   type: "number", // Tipo de input en el filtro
        //   typeG: "String", // Tipo definido en Graphql
        // },
        // {
        //   field: "dias_utilizados",
        //   label: "Días utilizados",
        //   type: "number", // Tipo de input en el filtro
        //   typeG: "String", // Tipo definido en Graphql
        // },
        // {
        //   field: "dias_saldo",
        //   label: "Días saldo",
        //   type: "number", // Tipo de input en el filtro
        //   typeG: "String", // Tipo definido en Graphql
        // },
        {
          field: "estado",
          label: "Estado gestión",
          type: "text", // Tipo de input en el filtro
          typeG: "String", // Tipo definido en Graphql
        },
      ],
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      gestion_desde: null,
      gestion_hasta: null,
      persona: null,
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    await this.verEstadoVacacion();
    // await this.cargarGestionesVacacion();
    this.onFilter();
    await this.comprobarAltaPersona();
    console.log(this.bandera_alta_persona,"6")
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
  },
  // Métodos y funciones del componente
  methods: {
    async comprobarAltaPersona() {
      let res = await this.$service.graphql({
        query: `
          query get($id: ID!){
            vListaPersonal(id: $id){
              nombre
              id_movilidad
              nro_doc
              fecha_ingreso
              item
              foto
              id_persona
              id_estado
              id_item
            }
          }
        `,
        variables: {
          id: this.$storage.get("user").id_persona,
        },
      });
      if (res.vListaPersonal.id_estado == 2) {
        this.bandera_alta_persona = false;
      }
    },
    mensajeBajaPersona() {
      this.$confirm("La persona esta de baja", () => {});
    },
    rechazarProgramacion() {
      this.$confirm("Usted no cuenta con vacaciones para programar", () => {});
    },
    crearActualizarVacaciones(item) {
      this.$bus.$emit("openDialogCrearActualizarVacaciones", item);
      this.updateList();
    },

    async cargarGestionesVacacion() {
      let user = this.$storage.get("user");
      let id_persona = user.id_persona;
      try {
        let res = await this.$service.graphql({
          query: `
						query{
                  vEstadoVacacions(id_persona: ${id_persona}){
                    rows{
                      nombre
                      dias_saldo
                      dias_asignados
                      dias_utilizados
                      dias_programados
                      dias_cta_vacacion
                      id
                      id_estado
                      id_persona
                      nombre
                      ingreso
                      gestion_desde
                      gestion_hasta
                      estado
                      cas
                      saldo_a_programar
                      total_dias_saldo
                      id_programacion
                      id_estado_programacion
                      id_unidad
                      estado_programacion
                      periodo
                    }
                  }
                } 
					`,
        });

        if (res.vEstadoVacacions.rows.length != 0) {
          this.estado_vacacion = res.vEstadoVacacions.rows;
          this.nombre = this.estado_vacacion[0].nombre;
          this.persona = this.estado_vacacion[0].id_persona;
        }
      } catch (error) {
        console.log(error);
      }
    },
    
    async verEstadoVacacion() {
      let user = this.$storage.get("user");
      let id_persona = user.id_persona;
      try {
        let rpta = await this.$service.graphql({
          query: `
				query{
            vMovimientosMovilidads(id_persona:${id_persona}){
                rows{
                  id
                  fecha_desde
                  fecha_incorporacion
                  id_persona
 
                }
              }
            }
					`,
        });
        console.log(
          rpta.vMovimientosMovilidads.rows.length,
          "--",
          rpta.vMovimientosMovilidads.rows[0].fecha_incorporacion
        );
        if (rpta.vMovimientosMovilidads.rows.length != 0) {
          if (rpta.vMovimientosMovilidads.rows[0].fecha_incorporacion != null) {
            this.fecha_ingreso =
              rpta.vMovimientosMovilidads.rows[0].fecha_incorporacion;
          } else {
            console.log("++++", this.fecha_ingreso);
            this.fecha_ingreso =
              "No existe registros de la fecha de su incorporación";
          }
        }
        console.log("******", this.fecha_ingreso);
        let res = await this.$service.graphql({
          query: `
						query{
                  vEstadoVacacions(id_persona: ${id_persona}){
                    rows{
                        nombre
                        dias_saldo
                        dias_asignados
                        dias_utilizados
                        dias_programados
                        dias_cta_vacacion
                        id
                        id_estado
                        id_persona
                        nombre
                        ingreso
                        gestion_desde
                        gestion_hasta
                        estado
                        cas
                        dias_a_programar
                    }
                  }
                } 
					`,
        });

        if (res.vEstadoVacacions.rows.length != 0) {
          this.estado_vacacion = res.vEstadoVacacions.rows;
          this.nombre = this.estado_vacacion[0].nombre;
          this.persona = this.estado_vacacion[0].id_persona;
        }
      } catch (error) {
        console.log(error);
      }
    },
    verReporte(item, valor) {
      item.reprogramacion = valor; //programacion=0,repro=1
      this.$bus.$emit("openDialogVerReporte", item);
    },
  },

  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarVacaciones,
    VerReporte,
  },
};
</script>

<style>
.celda2 {
  white-space: pre;
  word-wrap: break-word;
  background: rgba(0, 165, 151, 0.438);
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
  border: solid 0.0001em rgba(65, 144, 150, 0.589);
}
.estilo-cabecera-customizada {
  color: rgb(13, 87, 148);
  white-space: pre;
  word-wrap: break-word;
  font-weight: bolder;
  font-size: 1.1em;
}
#celda {
  background: rgba(158, 205, 241, 0.5);
}
#celda_morada {
  background: rgba(169, 127, 196, 0.5);
}
</style>


// WEBPACK FOOTER //
// src/components/admin/vacaciones/Index.vue